module.exports = __webpack_public_path__ + "img/logo-en.bfe627bf.svg";